"use client";

import { MAX_EMBEDDED_WALLET_ACCOUNTS } from "@/config/turnkey";
import { useListEmbeddedWalletAccounts } from "./use-list-embedded-wallet-accounts";

// Embedded-wallet account state plus the derived "at the account limit" flag. Callers must gate
// on isLoading/isError before trusting atMax: until the query resolves accounts is undefined, so
// atMax is false and an org that is actually full would read as having room. With the flag off, or
// enabled=false (e.g. the chooser dialog is closed), the query is disabled, so isLoading/isError are
// false and atMax is false. Pass enabled to defer the fetch until the data is actually needed.
export function useEmbeddedWalletAtMax(enabled = true) {
  const { data: accounts, isError, isLoading, refetch } = useListEmbeddedWalletAccounts(enabled);
  const atMax = (accounts?.length ?? 0) >= MAX_EMBEDDED_WALLET_ACCOUNTS;
  return { accounts, atMax, isError, isLoading, refetch };
}
